module.exports = __webpack_public_path__ + "img/wallet.e0deb91b.svg";